/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { XANO_BASE } from "../config/xano";
import { useGLTF, Edges } from '@react-three/drei'
import * as THREE from "three";
import { PreviewDestinationOutlines } from "./PreviewDestinationOutlines";
import { getViewportSceneTheme } from "../utils/viewportCanvasDefaults";
import { useObjectStore } from "../zustand/objects";


export default function ModelObject({ showDestinationOutline, ...props }) {
  const group = useRef()
  const viewportThemeOverride = useObjectStore((s) => s.viewportThemeOverride);
  const sceneTheme = getViewportSceneTheme(viewportThemeOverride);
  // const { nodes, materials } = useGLTF(props.url)
  const { nodes } = useGLTF(`${XANO_BASE}${props.pose.modelPath}`)
  // const { nodes, materials } = useGLTF(`/model/preset_models/${props.pose}-transformed.glb`)



  const material = new THREE.MeshStandardMaterial({
    color: props.colour,
    transparent: false, opacity: 1
  });


  return (
    <group visible={props.colour ? true : false} ref={group} {...props} dispose={null} onClick={(e) => {
      e.stopPropagation()
      props.clickFunction()
    }}
    >
      <group scale={1.1} position={[0, 0, 0]} ref={group} {...props} dispose={null}>
        <mesh geometry={nodes[props.pose.name] && nodes[props.pose.name].geometry} material={material} rotation={[0, Math.PI, 0]}>
          {nodes[props.pose.name] && <Edges
            scale={1}
            threshold={40} // Display edges only when the angle between two faces exceeds this value (default=15 degrees)
            color={sceneTheme.edgeColor}
            // color="grey"
          />}
          {showDestinationOutline && <PreviewDestinationOutlines />}
          </mesh>
      </group>
    </group>
  )
}





